const validatePassword = input =>
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!/$%@#*?&._-])(?=.*\d)[A-Za-z\d!/$%@#*?&._-]{6,45}$/.test(input);
export default validatePassword;
